import React, { Component, useEffect, useRef } from "react";
import "./App.scss";
import { HomePage } from "./midi/main/HomePage";
import MainContextProvider from "../src/midi/context/MainContext";
// import MidiDataContext from "web-midi-hooks/M"
import { BrowserRouter, Switch, Route } from "react-router-dom";
import { BearContextProvider } from "@sillyscribe95/bear-ui-web";

function App() {
  return (
    <MainContextProvider>
      <BearContextProvider chakra>
        <BrowserRouter>
          <Switch>
            <Route path="/:inst?:key?" component={HomePage} />
            {/* <MidiProvider> */}
            {/* <HomePage /> */}
            {/* </MidiProvider> */}
          </Switch>
        </BrowserRouter>
      </BearContextProvider>
    </MainContextProvider>
  );
}

export default App;
